module.exports = __webpack_public_path__ + "img/04-title-03.8eda4123.png";